module.exports = "/fonts/vendor/boxicons/boxicons.woff2?df635aaf04cd75132f620e37ada9247c";